import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import _ from 'underscore';

import { ButtonBack } from '../../components/ButtonBack';
import { List, ListItem } from '../../components/List';
import { Card } from '../../components/Card';
import { Button } from '../../components/Button';
import { HelmetComponent } from '../../components/Helmet';

import { api } from '../../server/api';
import { useAuth } from '../../hooks/useAuth';
import { numberWithCommas } from '../../utils/numberWithCommas';
import * as routes from '../../constants/Routes';

export function MyRescues() {
  const navigate = useNavigate();
  const { client, player } = useAuth();

  const [rescues, setRescues] = useState<Array<any>>([]);
  const [fiveRescues, setFiveRescues] = useState<Array<any>>([]);
  const [isViewAll, setIsViewAll] = useState<boolean>(false);

  useEffect(() => {
    getPlayerRescues();
  }, []);

  const getPlayerRescues = async () => {
    try {
      const parameters = {
        searchFunctionality: 'getPlayerRescues',
        userType: 'player',
        playerId: player.id,
        clientId: client.id,
      };

      const { data } = await api.post('/search', parameters);
      if (data.success) {
        let { rescuesSnap } = data.data;
        rescuesSnap = _.sortBy(rescuesSnap, 'createdAt').reverse();

        const sliceRescues = rescuesSnap.slice(0, 5);

        setRescues(rescuesSnap);
        setFiveRescues(sliceRescues);
      }
    } catch (error) {
      console.log('error getPlayerRescues', error);
    }
  };

  const handleViewAll = () => {
    setIsViewAll(!isViewAll);
  };

  const onHandleRescueDetails = (rescueId: string) => {
    navigate(`${routes.RESCUE_DETAILS}/${rescueId}`);
  };

  return (
    <>
      <HelmetComponent
        clientLogoURL={client?.logoURL}
        companyName={client?.companyName}
        clientFavicon={client?.favIcon}
        primaryColor={client?.primaryColor}
        secondaryColor={client?.secondaryColor}
        tabTitle={'Meus Resgates'}
      />
      <div className="container">
        <div className="row">
          <ButtonBack title="Meus resgates" />
        </div>
        <div className="row">
          <div className="col-sm-12">
            <div className="my-3">
              <Card>
                <List>
                  {isViewAll ? (
                    <>
                      {rescues &&
                        rescues.map((rescue) => (
                          <ListItem
                            onClick={() => onHandleRescueDetails(rescue.id)}
                            key={rescue.createdAt}
                            content={`${numberWithCommas(
                              rescue.redeemedPoints
                            )} ${client?.coinName ? client.coinName.replace(/\((\w+)\)/, (_, conteudo) => conteudo) : 'pontos'}`}
                            image={rescue.awards[0].premiumImage}
                            secondaryContent={
                              <Button
                                onClick={handleViewAll}
                                text={`Ver ${!isViewAll ? 'todos' : 'menos'}`}
                                color="flat"
                                icon="add"
                              />
                            }
                          />
                        ))}
                    </>
                  ) : (
                    <>
                      {fiveRescues &&
                        fiveRescues.map((rescue) => (
                          <ListItem
                            key={rescue.createdAt}
                            content={`${numberWithCommas(
                              rescue.redeemedPoints
                            )} ${client?.coinName ? client.coinName.replace(/\((\w+)\)/, (_, conteudo) => conteudo) : 'pontos'}`}
                            image={rescue.awards[0].premiumImage}
                            secondaryContent={
                              <Button
                                onClick={() => onHandleRescueDetails(rescue.id)}
                                text={`Ver Mais`}
                                color="flat"
                              />
                            }
                          />
                        ))}
                    </>
                  )}
                </List>
                <div className="d-flex justify-content-center mt-4">
                  <Button
                    onClick={handleViewAll}
                    text={`Ver ${!isViewAll ? 'todos' : 'menos'}`}
                    color="flat"
                    icon="add"
                  />
                </div>
              </Card>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
